<template>
    <div>
      <!-- <div class="create_time">{{ messageData.createTime }}</div>  -->
    <div :class="isExpanded ? 'active_card' : 'card_container'" @click="toggleExpand">
        <van-row>
            <van-col span="20">
                <div class="title" :style="{ color: isExpanded ? '#fff' : '' }">{{ $t(props.title || '') }}</div>
                 <div class="create_time">{{ messageData.createTime }}</div>
            </van-col>
            <van-col span="4" class="icon_container">
                <div v-if="messageData.status == 0"  class="active_collapse_icon"></div>
            </van-col>
        </van-row>
        <div class="msg_content" :style="{ fontWeight: isExpanded ? 'bold' : '' }" :class="{ collapsed: !isExpanded }">
            {{ displayedMessage }}
        </div>
        <div v-if="isExpanded">
            <img :src="attachement" width="30%" alt="">
        </div>
    </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref} from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()
const isExpanded = ref(false)
const emits = defineEmits(['openMessageContent'])
interface MessageData {
    content: string
    createTime: string
    status: number
}
const router = useRouter()
const props = defineProps<{
    messageData: MessageData
    title?: string
    attachement?: string
}>()
const fullMessage = ref(props.messageData.content)

const displayedMessage = computed(() =>
    isExpanded.value ? fullMessage : fullMessage.value.split('\n')[0]
)

const toggleExpand = () => {
    userStore.setReadMessage({
      ...props.messageData,
      title: props.title,
      attachment: props.attachement
    })
     emits('openMessageContent')
}

</script>
<style scoped>
.card_container {
    background: #024746;
    border-radius: 7px;
    padding: 15px;
    margin-top: 10px;
}

.active_card {
    background: #024746;
    border: .02667rem solid #046acc;
    border-radius: 7px;
    padding: 15px;
    margin-top: 10px;
    overflow: hidden;
}

.collapse_icon {
    background: rgba(255, 255, 255, 0.20);
    width: 10px;
    border-radius: 30px;
    padding: 2px;
    height: 10px;
}

.collapse_icon img {
    width: 10px;
}

.active_collapse_icon {
    background: red;
    width: 5px;
    border-radius: 30px;
    padding: 2px;
    height: 5px;
}

.active_collapse_icon img {
    width: 15px;
}

.icon_container {
    display: flex;
    justify-content: right;
}

.title {
    color: #fff;
    font-size: 18px;
    font-weight: 500;
}

.create_time {
    color: rgba(255, 255, 255, .6);
    font-size: 12px;
    padding: 5px 0;
    display: flex;
    justify-content: flex-start;
    font-weight: 600;
}

.msg_content {
    margin: 10px 0;
    color: rgba(255, 255, 255, .6);
    font-size:14px;
    line-height: 20px;
    font-weight: 700;
    white-space: pre-wrap;
    overflow-wrap: break-word; 
    word-wrap: break-word;
    word-break: break-all;
    font-family: "Roboto", "Helvetica Neue", sans-serif;
}

.msg_content.collapsed {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

@media (max-width: 360px) {
  .card_container,
  .active_card {
    padding: 10px;
    border-radius: 6px;
  }

  .title {
    font-size: 15px;
  }

  .create_time {
    font-size: 13px;
    padding: 6px 0;
  }

  .msg_content {
    font-size: 12px;
    line-height: 18px;
    margin: 8px 0;
  }

  .active_collapse_icon {
    width: 4px;
    height: 4px;
  }
}

</style>